<template>
    <div class="wrapper d-flex h-100">
        <div id="contents" :class="{ 'mobile-contents': isMobile }">
            <NotificationPermissionAlert
                v-if="isNotifyShowing && !isAdmin && !notifyIgnored && false"
                @close="isNotifyShowing = false"
            />

            <div class="suspend-notify" v-if="suspend">
                <div class="content">
                    <div class="title">{{ $t("message.suspendedMessage") }}</div>
                    <div class="description">{{ $t("message.suspendedDescription") }}</div>
                </div>
            </div>

            <Header />
            <div class="main-content" :class="{ suspend }">
                <Sidebar />
                <div class="content-view" :class="{ 'menu-active': menu.isOpen || menu.hoverActive }">
                    <router-view class="content-view-child" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Sidebar from "../components/Sidebar.vue";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { mapActions, mapState } from "vuex";
import NotificationPermissionAlert from "./NotificationPermissionAlert.vue";

export default {
    name: "Layout",
    components: {
        Sidebar,
        Header,
        Footer,
        NotificationPermissionAlert,
    },
    data() {
        return {
            isNotifyShowing: Notification.permission !== "granted",
        };
    },
    computed: {
        ...mapState({
            menu: (state) => state.layout.menu,
            user: (state) => state.auth.user,
            token: (state) => state.auth.token,
            adminUser: (state) => state.auth.adminUser,
            isAdmin: (state) => !!state.auth.adminUser,
            offlineMode: (state) => state.setting.offlineMode,
            suspend: (state) => state.site.site.suspend,
            largeHeader: (state) => state.app.largeHeader,
            isMobile: (state) => state.app.isMobile,
        }),
        notifyIgnored() {
            return sessionStorage.getItem("dismissed-notify-alert") === "true";
        },
    },
    methods: {
        ...mapActions({
            getUser: "auth/profile",
            getAdminUser: "auth/adminProfile",
        }),
    },
    mounted() {
        if (this.user) {
            this.getUser();
        }

        if (this.adminUser) {
            this.getAdminUser();
        }
    },
};
</script>

<style lang="scss">
$breadcrumb-height: 45px;
.suspend-notify {
    background-color: #ffe027;
    color: #3692ff;
    font-family: "Poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    padding: 20px;

    .material-icons {
        font-size: 50px;
    }

    .content {
        display: flex;
        flex-direction: column;
        align-items: center;

        .title {
            font-weight: bold;
            font-size: 28px;
            text-transform: uppercase;
        }

        .description {
            font-size: 22px;
        }
    }
}

#contents.mobile-contents {
    .page-content-wrapper {
        margin-left: 60px;
    }
}

.wrapper {
    .a-link {
        color: var(--a-tag-color) !important;
        text-decoration: underline;
    }
    .main-content {
        display: flex;
        width: 100vw;
        overflow: hidden;
        height: calc(100vh - 55px);
        position: relative;
        background-color: var(--color-bg-neutral-default);
        &.suspend {
            height: calc(100vh - 55px - 80px);
        }
        .content-view {
            border-top-left-radius: 20px;
            height: 100%;
            border-top: 1px solid var(--color-border-default);
            border-left: 1px solid var(--color-border-default);
            width: 100%;
            background: var(--color-bg-default) !important;
            overflow-x: hidden;
            overflow-y: auto;

            .content-view-child {
                background-color: var(--color-bg-default) !important;
                height: 100%;

                .route-page-content {
                    height: 100%;

                    &.breadcrumb-content {
                        height: calc(100% - $breadcrumb-height);
                    }

                    width: 100%;
                    overflow-y: auto;
                    overflow-x: hidden;
                    display: flex;
                    align-items: flex-start;
                }

                .page-content-wrapper {
                    height: 100%;
                    width: 100%;
                    overflow: auto;
                    overflow-x: hidden;
                }
            }
        }
    }
}
</style>
